import { Capacitor, registerPlugin } from '@capacitor/core';

/**
 * O `tabletId` do aplicativo: no Android é o ANDROID_ID do aparelho (plugin nativo `Dispositivo`,
 * `DispositivoPlugin.java`). Ele vai na URL do WebSocket e no campo `dispositivo` do login, que o
 * servidor grava em `tentativa_login`/`sessao` e o painel mostra no Log.
 *
 * O teste no tablet real mostrou que IMEI e número de série não são acessíveis a um app comum;
 * o ANDROID_ID é. Fora do Android (navegador, dev) ou se o plugin falhar, vale o id do build
 * (`VITE_TABLET_ID`), como antes — o login nunca trava por causa da identificação.
 */
const Dispositivo = registerPlugin('Dispositivo');

/** O servidor aceita no máximo 120 caracteres em `dispositivo`; o ANDROID_ID tem 16. */
const LIMITE_DO_CAMPO = 120;

export async function identificarTablet(
    padrao,
    { nativo = Capacitor.isNativePlatform(), plugin = Dispositivo } = {},
) {
    if (!nativo) return padrao;
    try {
        const { androidId } = await plugin.identificar();
        const id = String(androidId ?? '').trim();
        return id ? id.slice(0, LIMITE_DO_CAMPO) : padrao;
    } catch (erro) {
        console.warn('[App] ANDROID_ID indisponível; usando o id do build.', erro);
        return padrao;
    }
}
